var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var separator = decimal;
    
    if (decimal == null || decimal == "") {
      // Fetch the separator from the number
      var detectedSeparator = [...number.matchAll(/\d+([\.|,])/gm)].reverse().map(m => m[1])[0];
      separator = detectedSeparator !== undefined ? detectedSeparator : '.';
    }
    
    var parts   = number.split(separator),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (separator + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};


document.addEventListener("DOMContentLoaded", function() {

  var theme = theme || {};

  fetch("https://geoip.lab401.workers.dev/index.json")
    .then(response => response.json())
    .then(data => geoip(data))
    .catch(error => {
      console.log("GeoIP Failed, forcing non-VAT Region");
      geoip({'country': 'US'});
    });

    function geoip(json){
      const EEAList = {
        "DE": 19,
        "AT": 20,
        "BE": 21,
        "BG": 20,
        "CY": 19,
        "HR": 25,
        "DK": 25,
        "ES": 21,
        "EE": 22,
        "FI": 24,
        "FR": 20,
        "GR": 24,
        "HU": 27,
        "IE": 23,
        "IT": 22,
        "LV": 21,
        "LT": 21,
        "LU": 17,
        "MT": 18,
        "NL": 21,
        "PL": 23,
        "PT": 23,
        "CZ": 21,
        "RO": 19,
        "SK": 20,
        "SI": 22,
        "SE": 25,
        "UA": 25
      }

      console.log("Detected Country: "+json.country.toUpperCase())

      var shippingCountry = document.getElementById('shipping-country');
      if (shippingCountry) {
          shippingCountry.value = json.country.toLowerCase();
          shippingCountry.dispatchEvent(new Event('change'));
      }
      
      if (json.country.toUpperCase() in EEAList) {
          console.log("EU Country detected, setting TVA");
          taxHandler.setTaxPreference(true)
          taxHandler.setTaxRate(1 + EEAList[json.country.toUpperCase()] / 100);
          setTaxPreferenceChecked()
      } else {
        console.log("Non EU Country detected, unsetting TVA");
        taxHandler.setTaxRate(1.0);
      }
    }

  theme.tax = function(defaultSelector, taxSelector, taxRate) {
    var selectorDefault = defaultSelector;
    var selectorTax = taxSelector;

    return {
      initPrices: function(container) {
        const taxRate = this.getTaxRate();
        if(!isNaN(taxRate)) {
          const existingTaxElement = container.querySelector(selectorTax);
          const defaultDisplay = this.getTaxPreference() ? 'none' : 'block';
          const taxDisplay = this.getTaxPreference() ? 'block' : 'none';
          const price = parseFloat(container.getAttribute('item-price'));
          const compare_at_price = parseFloat(container.getAttribute('item-compare_at_price'));
          const updatedPrice = price * taxHandler.getTaxRate();
          const updatedCompreAtPrice = compare_at_price * taxHandler.getTaxRate();
          container.querySelector(selectorDefault).style.display = defaultDisplay;

          if (!existingTaxElement) {
            const formattedUpdatedPrice = Shopify.formatMoney(updatedPrice, moneyFormat);

            // Fetch the separator from the number
            var separator = [...formattedUpdatedPrice.matchAll(/\d+([\.|,])/gm)].reverse().map(m => m[1])[0];
            
            let integerPart, fractionalPart;
            if (separator === undefined) {
              // No separator found - price has no decimals
              integerPart = formattedUpdatedPrice;
              fractionalPart = "";
            } else {
              // Separator found - split the price
              [integerPart, fractionalPart] = formattedUpdatedPrice.split(separator);
            }
            
            const taxElement = document.createElement('small');
            taxElement.setAttribute('aria-hidden', 'true');
            taxElement.setAttribute('data-tax', '');
            taxElement.innerHTML = fractionalPart ? integerPart + '<sup>' + fractionalPart + '</sup>' : integerPart;
            const priceContainer = container.querySelector('[data-prices]');

            if (priceContainer) {
              priceContainer.appendChild(taxElement);
            }
            taxElement.style.display = taxDisplay;
          } else {
            existingTaxElement.style.display = taxDisplay;
          }

          if (compare_at_price && price < compare_at_price) {
            const priceDifferenceWithTaxes = Math.abs(updatedPrice - updatedCompreAtPrice);
            const formattedDifferenceWithTaxes = Shopify.formatMoney(priceDifferenceWithTaxes, moneyFormat);
            const priceDifferenceWithoutTaxes = Math.abs(price - compare_at_price);
            const formattedDifferenceWithoutTaxes = Shopify.formatMoney(priceDifferenceWithoutTaxes, moneyFormat);

            const existingSaleTags = container.querySelectorAll('.sale-tag');
            existingSaleTags.forEach(tag => tag.remove());

            const saleTag = document.createElement('div');
            saleTag.classList.add('sale-tag');

            if (this.getTaxPreference()) {
              saleTag.textContent = 'Save ' + formattedDifferenceWithTaxes;
            } else {
              saleTag.textContent = 'Save ' + formattedDifferenceWithoutTaxes;
            }

            container.appendChild(saleTag);
          }
        }
      },

      determineTax: function(variant) {
        if (this.getTaxPreference()) {
          variant.tax_price = variant.price * this.getTaxRate();
          variant.tax_compare_at_price = variant.compare_at_price * this.getTaxRate();
        }
        return variant;
      },

      getTaxPreference: function() {
        return (localStorage.getItem("tax_preference") === "true");
      },

      setTaxPreference: function(taxPreference) {
        localStorage.setItem("tax_preference", taxPreference);
        return true;
      },

      setTaxRate: function(newTaxRate) {
          localStorage.setItem("tax_rate", newTaxRate);
      },

      setDefaultTaxPreference: function(defaultMode) {
        if (localStorage.getItem("tax_preference") === null) {
          this.setTaxPreference(defaultMode);
        }
      },

      getTaxRate: function() {
        return parseFloat(localStorage.getItem("tax_rate"));
      },
    };
  };

  var taxHandler = theme.tax('[data-no-tax]', '[data-tax]');
  window.taxHandler = taxHandler;

  var taxPreferenceDesktop = document.querySelector('.site-navigation-wrapper #tax_preference');
  var taxPreferenceMobile = document.querySelector('#site-mobile-nav #tax_preference');

  function setTaxPreferenceChecked() {
    const checkboxes = document.querySelectorAll('[id="tax_preference"]');
    checkboxes.forEach((checkbox) => {
      checkbox.checked = true;
      const changeEvent = new Event('change', { bubbles: true });
      checkbox.dispatchEvent(changeEvent);
    });
  }

  function setInitialTaxPreferenceState() {
    var taxPreferenceCheckbox;
    if (window.innerWidth >= 1024 && taxPreferenceDesktop) {
      taxPreferenceCheckbox = taxPreferenceDesktop;
    } else if (window.innerWidth < 1024 && taxPreferenceMobile) {
      taxPreferenceCheckbox = taxPreferenceMobile;
    }

    if (taxPreferenceCheckbox) {
      taxPreferenceCheckbox.checked = taxHandler.getTaxPreference();
      document.querySelectorAll('[data-product-item-content]').forEach(function(container) {
        taxHandler.initPrices(container);
      });
    }
  }

  setInitialTaxPreferenceState()

  function updateTaxPreference(checkbox) {
    taxHandler.setTaxPreference(checkbox.checked);

    document.querySelectorAll('[data-product-item-content]').forEach(function(container) {
      taxHandler.initPrices(container);
    });

    cartPriceUpdate();
  }

  if (taxPreferenceDesktop) {
    taxPreferenceDesktop.addEventListener('change', function() {
      updateTaxPreference(taxPreferenceDesktop);
    });
  }

  if (taxPreferenceMobile) {
    taxPreferenceMobile.addEventListener('change', function() {
      updateTaxPreference(taxPreferenceMobile);
    });
  }

  const waitUntilElementAppear = setInterval(waitUntilElementsAreCreated, 1000);

  function waitUntilElementsAreCreated() {
    const products = document.querySelectorAll('[data-recently-viewed-container] [data-product-item-content], [data-product-recommendations] [data-product-item-content]');
    if (products.length > 0) {
      clearInterval(waitUntilElementAppear);
      products.forEach(function(container) {
        taxHandler.initPrices(container);
      });
    }
  }

  waitUntilElementsAreCreated();


  function cartPriceUpdate() {
      console.log('Tax update triggered');
      if(document.querySelector('.template-cart')){
      const moneyFormatScript = document.querySelector('[data-section-type="static-cart"]');
      const moneyFormatData = JSON.parse(moneyFormatScript.textContent.trim());
      const moneyFormat = moneyFormatData.settings.money_format;

      const moneyElements = document.querySelectorAll('.template-cart .money');
      moneyElements.forEach(function(element) {
        const price = parseFloat(element.getAttribute('data-default-price'));
        if(taxHandler.getTaxPreference()){
          const updatedPrice = price * taxHandler.getTaxRate();
            element.textContent = Shopify.formatMoney(updatedPrice, moneyFormat);
        } else {
            element.textContent = Shopify.formatMoney(price, moneyFormat);
        }
      });
    }
  }

  document.querySelectorAll('.quantity-selector__button').forEach(function(btn) {
    btn.addEventListener('click', function() {
      cartPriceUpdate();
    });
  });

  document.querySelectorAll('.quantity-selector__input').forEach(function(input) {
    input.addEventListener('change', function() {
      cartPriceUpdate();
    });
  });


  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      cartPriceUpdate();
    }
  });

});
